<script>
  import { onMount } from "svelte";
  let time = new Date();

  $: timeText = time.toLocaleTimeString("en-US", {
    hour12: false,
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });

  onMount(() => {
    const interval = setInterval(() => {
      time = new Date();
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });
</script>

<h3>
  Current Time
  <span
    class="block text-2xl md:text-4xl 2xl:text-7xl text-shadow-lg font-semibold text-green-300 whitespace-pre-wrap font-mono"
  >
    {timeText}
  </span>
</h3>
